<script setup>

import { defineProps, defineEmits, ref, computed, watch} from "vue";
import { watchDebounced } from '@vueuse/core';
import { DateTime } from "luxon";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "somaCustoAdicional",
    "parcela",
    "parcelasCondicoesDePagamento",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:alteraParcela",
    "update:removeParcelaRascunho"
]);

//==================================================================//
//========================= Parcela Tipos ==========================//
//==================================================================//

let parcelaTipos = ref([
    "Adiantamento",
    "Faturamento",
    "Nota de Débito",
    "Retenção",
    "Data Book"
]);

//==================================================================//
//======================= Referencia Evento ========================//
//==================================================================//

let referenciaEventos = ref([
    "C/Entrega",
    "C/Pedido de compra"
]);

//==================================================================//
//=========================== Formulario ===========================//
//==================================================================//

const formulario = ref(null);

//==================================================================//
//========================= Altera Parcela =========================//
//==================================================================//

const alteraParcela = (update = {}) =>{

    update.id = props?.parcela?.id;
    emits('update:alteraParcela', update);

};

//==================================================================//
//===================== Remove Parcela Rascunho ====================//
//==================================================================//

const removeParcelaRascunho = () =>{

    emits('update:removeParcelaRascunho',{
        id: props?.parcela?.id
    });

};

//==================================================================//
//==================== Parcela Descrição Regras ====================//
//==================================================================//

const parcelaDescricaoRegras = [
    valor => {
        if(valor == null){
            return false;
        }
        return true;
    }
];

//==================================================================//
//=================== Parcela Data Entrega Regras ==================//
//==================================================================//

const parcelaDataEntregaRegras = [
    valor => {
        if(valor == "Invalid DateTime"){
            return false;
        }
        if(valor == ""){
            return false;
        }
        return true;
    }
];

//==================================================================//
//================= Parcela Dias Vencimento Regras =================//
//==================================================================//

const parcelaDiasVencimentoRegras = [
    valor => {
        if(valor === ""){
            return false;
        }else if(valor < 0){
            return false;
        }
        return true;
    }
];

//==================================================================//
//================= Parcela Data Vencimento Regras =================//
//==================================================================//

const parcelaDataVencimentoRegras = [
    valor => {
        if(valor == ""){
            return false;
        }
        return true;
    }
];

//==================================================================//
//=================== Parcela Percentual Regras ====================//
//==================================================================//

const parcelaPercentualRegras = [
    valor => {
        if(valor == ""){
            return false;
        }else if(valor < 0 || valor > 100){
            return false;
        }
        return true;
    }
];

//==================================================================//
//===================== Parcela Valor Regras =======================//
//==================================================================//

const parcelaValorRegras = [
    valor => {

        if(valor == ""){
            return false;
        }else if(valor == "0,00"){
            return false;
        }
        return true;
    }
];

//==================================================================//
//=========================== Parcela Tipo =========================//
//==================================================================//

const parcelaTipo = computed(()=>{

    if(props?.parcela?.status == "Leitura"){
        return "Leitura"
    }

    if(props?.parcela?.nova == true){
        return "Nova"
    }

    return "Rascunho"

});

//==================================================================//
//======================== Parcela Status Cor ======================//
//==================================================================//

const parcelaStatusCor = computed(()=>{

    if(props?.parcela?.status == "Leitura"){
        return "gray"
    }

    if(props?.parcela?.status == "Salvo"){
        return "green"
    }

    if(props?.parcela?.status == "Valido"){
        return "orange"
    }

    return "red"

});

//==================================================================//
//======================= Desativa Parcela =========================//
//==================================================================//

const desativaParcela = computed(()=>{

    if(props?.parcela?.leitura == true){
        return true
    }

    if(props?.controlesDesativados == true){
        return true
    }

    return false;

});

//==================================================================//
//================== Parcela Nova Remover Label ====================//
//==================================================================//

const parcelaNovaRemoverLabel = computed(()=>{

    return props?.parcela?.remover ? "✓ Sim" : "Não"

});

//==================================================================//
//===================== Parcela Nova Remover Cor ===================//
//==================================================================//

const parcelaNovaRemoverCor = computed(()=>{

    if(props?.parcela?.remover == true){
        return "#212121"
    }

    return "red"

});

//==================================================================//
//=================== Ao Remover Parcela Nova ======================//
//==================================================================//

const aoRemoverParcelaNova = () =>{

    alteraParcela({
        remover: !props?.parcela?.remover,
    })
    
};

//==================================================================//
//=============== Ao Remover Parcela Rascunho ======================//
//==================================================================//

const aoRemoverParcelaRascunho = () =>{

   removeParcelaRascunho();
    
};

//==================================================================//
//========================== Altera Tipo ===========================//
//==================================================================//

const alteraTipo = (tipo) =>{

    alteraParcela({
        tipo: tipo
    })

};

//==================================================================//
//======================== Altera Descrição ========================//
//==================================================================//

const alteraDescricao = (condicaoDePagamento) =>{

    if(condicaoDePagamento?.id){

        alteraParcela({
            descricao: condicaoDePagamento?.descricao,
            diasVencimento: condicaoDePagamento?.diasVencimento
        });

    }else{

        alteraParcela({
            descricao: condicaoDePagamento,
        });

    }
    
};

//==================================================================//
//================= Obtem Data Entreta Formatada ===================//
//==================================================================//

const obtemDataEntregaFormatada = () =>{

    let dataEntrega = DateTime.fromFormat(props?.parcela?.dataEntrega,"dd/MM/yyyy");
    return dataEntrega.toFormat("yyyy-MM-dd");

};

//==================================================================//
//==================== Altera Data de Entrega ======================//
//==================================================================//

const alteraDataEntrega = (dataEntrega) =>{

    dataEntrega = DateTime.fromFormat(dataEntrega,"yyyy-MM-dd");
    dataEntrega = dataEntrega.toFormat("dd/MM/yyyy");

    alteraParcela({
        dataEntrega: dataEntrega
    });

};

//==================================================================//
//==================== Altera Dias Vencimento ======================//
//==================================================================//

const alteraDiasVencimento = (diasVencimento) =>{

    alteraParcela({
        diasVencimento: Number(diasVencimento||0)
    })

};

//==================================================================//
//======================== Data Vencimento =========================//
//==================================================================//

const dataVencimento = computed(()=>{

    if(props?.parcela?.diasVencimento === ""){
        return "";

    }else if(props?.parcela?.diasVencimento < 0){
        return "";

    }else if(props?.parcela?.dataEntrega == ""){
        return "";
    }

    let dataEntrega = DateTime.fromFormat(props?.parcela?.dataEntrega,"dd/MM/yyyy").plus({days: props?.parcela?.diasVencimento }).startOf("day");
    
    let dataVencimento = DateTime.fromFormat(props?.parcela?.dataEntrega,"dd/MM/yyyy").set({weekday: 3}).startOf("day");

    if(dataEntrega > dataVencimento){

        // Pega a próxima Quarta Feira.
        dataVencimento = dataEntrega.plus({days: (7 - dataEntrega.weekday + 3) % 7});

    }

    return dataVencimento.toFormat("yyyy-MM-dd");

});

//==================================================================//
//====================== Altera Percentual =========================//
//==================================================================//

const alteraPercentual = (percentual) => {

    percentual = Number(percentual);
    
    let valor = props?.somaCustoAdicional * percentual / 100;

    alteraParcela({
        percentual: percentual,
        valor: valor
    })

}; 

//==================================================================//
//======================= Valor Formatado ==========================//
//==================================================================//

const valorFormatado = computed(() =>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.parcela?.valor);

});

//==================================================================//
//==================== Altera Referencia Evento ====================//
//==================================================================//

const alteraReferenciaEvento = (referenciaEvento) => {

    alteraParcela({
        referenciaEvento: referenciaEvento
    })

}

//==================================================================//
//=========================== Validate =============================//
//==================================================================//

const validate = () =>{

    return formulario.value.validate();

}

//==================================================================//
//====================== Validate Formatado ========================//
//==================================================================//

const validateFormatado = computed(()=>{

    return validate() ? "Valido" : "Invalido";

});

//==================================================================//
//=================== Calcula Valor da Parcela  ====================//
//==================================================================//

const calculaValorDaParcela = () => {

    let parcelaValor = props?.somaCustoAdicional * props?.parcela?.percentual / 100;

    alteraParcela({
        valor: parcelaValor
    })

};

//==================================================================//
//======================= Watch => Parcela =========================//
//==================================================================//

watch(()=> props.somaCustoAdicional, () => {

    if(props?.parcela?.status == "Leitura"){
        return;
    }

    calculaValorDaParcela();

});

//==================================================================//
//================= Watch Effect => Parcela ========================//
//==================================================================//

watchDebounced(() => props?.parcela, () => {

    let parcelaStatusAtual = props?.parcela?.status;
    let parcelaStatusValidacao = validateFormatado.value;

    if(parcelaStatusAtual == parcelaStatusValidacao){
        return;
    }

    alteraParcela({
        status: parcelaStatusValidacao
    })

},{ debounce: 500, maxWait: 1000 })

</script>

<template>

    <v-form
        ref="formulario"
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    :color="parcelaStatusCor"
                    dark
                >
                    {{ props?.parcela?.status }}
                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    v-if="parcelaTipo == 'Nova'"
                    @click.stop="aoRemoverParcelaNova"
                    class="c-botao-remover-parcela-nova"
                    :color="parcelaNovaRemoverCor"
                    dark
                >
                    {{ parcelaNovaRemoverLabel }}
                </v-chip>

                <v-chip
                    v-else-if="parcelaTipo == 'Rascunho'"
                    @click.stop="aoRemoverParcelaRascunho"
                    class="c-botao-remover-parcela-rascunho"
                    color="red"
                    dark
                >
                    <v-icon>mdi-trash-can-outline</v-icon>
                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-select
                    class="c-campo__input"
                    label="Tipo"
                    :value="props?.parcela?.tipo"
                    :items="parcelaTipos"
                    :disabled="desativaParcela"
                    outlined
                    required
                    hide-details
                    @input="alteraTipo"
                ></v-select>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-combobox
                    class="c-campo__input"
                    :value="props?.parcela?.descricao"
                    :items="props?.parcelasCondicoesDePagamento"
                    :rules="parcelaDescricaoRegras"
                    label="Descrição"
                    item-text="descricao"
                    outlined
                    prepend-icon="mdi-pen"
                    clearable
                    hide-details
                    :disabled="desativaParcela"
                    @change="alteraDescricao"
                ></v-combobox>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    :value="obtemDataEntregaFormatada()"
                    :rules="parcelaDataEntregaRegras"
                    label="Data de Entrega"
                    type="date"
                    outlined
                    hide-details
                    hide-spin-buttons
                    required
                    :disabled="desativaParcela"
                    @input="alteraDataEntrega"
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    :value="props?.parcela?.diasVencimento"
                    label="Dias"
                    outlined
                    type="number"
                    hide-details
                    append-icon="mdi-calendar-arrow-right"
                    :disabled="desativaParcela"
                    :rules="parcelaDiasVencimentoRegras"
                    @input="alteraDiasVencimento"
                    required
                ></v-text-field>

            </div>
            
        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    :value="dataVencimento"
                    label="Data Vencimento"
                    outlined
                    type="date"
                    disabled
                    required
                    hide-details
                    :rules="parcelaDataVencimentoRegras"
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    v-show="!props?.parcela?.leitura"
                    :value="props?.parcela?.percentual"
                    label="Percentual"
                    outlined
                    type="number"
                    append-icon="mdi-percent"
                    :disabled="desativaParcela"
                    :rules="parcelaPercentualRegras"
                    required
                    hide-details
                    hide-spin-buttons
                    @input="alteraPercentual"
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    label="Valor"
                    :value="valorFormatado"
                    :rules="parcelaValorRegras"
                    outlined
                    prepend-inner-icon="mdi-currency-brl"
                    disabled
                    hide-details
                    hide-spin-buttons
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-select
                    label="Tipo"
                    class="c-campo__input"
                    :value="props?.parcela?.referenciaEvento"
                    :items="referenciaEventos"
                    :disabled="desativaParcela" 
                    outlined
                    hide-details
                    required
                    @input="alteraReferenciaEvento"
                ></v-select>

            </div>

        </div>

    </v-form>

</template>

<style scoped>

.c-formulario{
    display: contents !important;
    background-color: #e9e9e9;
    padding: 5px;
}

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-botao-remover-parcela-nova{
    cursor: pointer;
}

.c-botao-remover-parcela-rascunho{
    cursor: pointer;
}

</style>